module.exports = __webpack_public_path__ + "media/styles/images/png/circle-right-arrow-gray-light-on-white-83678ddc38a88df706006cb95ef87460.png";